/* js/pages/EnCheminPage.svelte generated by Svelte v3.46.4 */
import {
	SvelteComponent,
	append,
	attr,
	check_outros,
	create_component,
	destroy_component,
	destroy_each,
	detach,
	element,
	empty,
	group_outros,
	init,
	insert,
	mount_component,
	safe_not_equal,
	set_data,
	space,
	text,
	transition_in,
	transition_out
} from "svelte/internal";

import Header from '../components/Header.svelte';

// import Map from '../components/Map.svelte';
import MapLibre from '../components/MapLibre.svelte';

// import SpotMarker from '../components/SpotMarker.svelte'
import SpotMarkerLibre from '../components/SpotMarkerLibre.svelte';

// import UserMarker from '../components/UserMarker.svelte';
import UserMarkerLibre from '../components/UserMarkerLibre.svelte';

import MapPointerButton from '../components/MapPointerButton.svelte';
import ParcoursPath from '../components/ParcoursPath.svelte';
import GeoLocationStartButton from '../components/GeoLocationStartButton.svelte';

import {
	geoLocationManager,
	GeolocationEventType,
	GeoLocationServiceState
} from '../GeoLocationManager';

import { appRouter } from '../appRouter.js';
import { computeBounds, lineFeatureCollectionFromPoints } from '../geoUtils';
import { db } from '../Db.js';
import { mapEventProvider } from '../mapEventProvider.js';
import { onMount, onDestroy } from 'svelte';
import { flyToProvider } from '../providers.js';
import distance from '@turf/distance';
import { HalteParentType } from '../HalteParentType';

function get_each_context(ctx, list, i) {
	const child_ctx = ctx.slice();
	child_ctx[21] = list[i];
	child_ctx[23] = i;
	return child_ctx;
}

// (218:0) {#if halte}
function create_if_block(ctx) {
	let div;
	let maplibre;
	let current;

	maplibre = new MapLibre({
			props: {
				startCoordinates: /*halte*/ ctx[0].coordinates,
				startZoom: 15,
				onLoad: /*onMapLoaded*/ ctx[7],
				$$slots: { default: [create_default_slot] },
				$$scope: { ctx }
			}
		});

	return {
		c() {
			div = element("div");
			create_component(maplibre.$$.fragment);
			attr(div, "class", "map-container svelte-1bsnlr7");
		},
		m(target, anchor) {
			insert(target, div, anchor);
			mount_component(maplibre, div, null);
			current = true;
		},
		p(ctx, dirty) {
			const maplibre_changes = {};
			if (dirty & /*halte*/ 1) maplibre_changes.startCoordinates = /*halte*/ ctx[0].coordinates;

			if (dirty & /*$$scope, haltePoints, halte, parcoursPath, mapIsReady, autoCenteringActive*/ 16777247) {
				maplibre_changes.$$scope = { dirty, ctx };
			}

			maplibre.$set(maplibre_changes);
		},
		i(local) {
			if (current) return;
			transition_in(maplibre.$$.fragment, local);
			current = true;
		},
		o(local) {
			transition_out(maplibre.$$.fragment, local);
			current = false;
		},
		d(detaching) {
			if (detaching) detach(div);
			destroy_component(maplibre);
		}
	};
}

// (224:12) {#if parcoursPath && mapIsReady}
function create_if_block_1(ctx) {
	let parcourspath;
	let t;
	let each_1_anchor;
	let current;

	parcourspath = new ParcoursPath({
			props: {
				pathData: /*parcoursPath*/ ctx[3],
				parcoursSlug: /*halte*/ ctx[0].parentSlug,
				pathColor: "#222",
				lineWidth: 6
			}
		});

	let each_value = /*haltePoints*/ ctx[4];
	let each_blocks = [];

	for (let i = 0; i < each_value.length; i += 1) {
		each_blocks[i] = create_each_block(get_each_context(ctx, each_value, i));
	}

	const out = i => transition_out(each_blocks[i], 1, 1, () => {
		each_blocks[i] = null;
	});

	return {
		c() {
			create_component(parcourspath.$$.fragment);
			t = space();

			for (let i = 0; i < each_blocks.length; i += 1) {
				each_blocks[i].c();
			}

			each_1_anchor = empty();
		},
		m(target, anchor) {
			mount_component(parcourspath, target, anchor);
			insert(target, t, anchor);

			for (let i = 0; i < each_blocks.length; i += 1) {
				each_blocks[i].m(target, anchor);
			}

			insert(target, each_1_anchor, anchor);
			current = true;
		},
		p(ctx, dirty) {
			const parcourspath_changes = {};
			if (dirty & /*parcoursPath*/ 8) parcourspath_changes.pathData = /*parcoursPath*/ ctx[3];
			if (dirty & /*halte*/ 1) parcourspath_changes.parcoursSlug = /*halte*/ ctx[0].parentSlug;
			parcourspath.$set(parcourspath_changes);

			if (dirty & /*haltePoints, halte, detectionRadius, gotoNextHalte*/ 81) {
				each_value = /*haltePoints*/ ctx[4];
				let i;

				for (i = 0; i < each_value.length; i += 1) {
					const child_ctx = get_each_context(ctx, each_value, i);

					if (each_blocks[i]) {
						each_blocks[i].p(child_ctx, dirty);
						transition_in(each_blocks[i], 1);
					} else {
						each_blocks[i] = create_each_block(child_ctx);
						each_blocks[i].c();
						transition_in(each_blocks[i], 1);
						each_blocks[i].m(each_1_anchor.parentNode, each_1_anchor);
					}
				}

				group_outros();

				for (i = each_value.length; i < each_blocks.length; i += 1) {
					out(i);
				}

				check_outros();
			}
		},
		i(local) {
			if (current) return;
			transition_in(parcourspath.$$.fragment, local);

			for (let i = 0; i < each_value.length; i += 1) {
				transition_in(each_blocks[i]);
			}

			current = true;
		},
		o(local) {
			transition_out(parcourspath.$$.fragment, local);
			each_blocks = each_blocks.filter(Boolean);

			for (let i = 0; i < each_blocks.length; i += 1) {
				transition_out(each_blocks[i]);
			}

			current = false;
		},
		d(detaching) {
			destroy_component(parcourspath, detaching);
			if (detaching) detach(t);
			destroy_each(each_blocks, detaching);
			if (detaching) detach(each_1_anchor);
		}
	};
}

// (226:16) {#each haltePoints as haltePoint, index}
function create_each_block(ctx) {
	let spotmarkerlibre;
	let current;

	spotmarkerlibre = new SpotMarkerLibre({
			props: {
				id: /*index*/ ctx[23],
				isLast: /*index*/ ctx[23] == /*haltePoints*/ ctx[4].length - 1,
				coords: /*haltePoint*/ ctx[21],
				isCurrent: /*index*/ ctx[23] == /*halte*/ ctx[0].idx,
				showRadius: /*index*/ ctx[23] != /*halte*/ ctx[0].idx - 1,
				radiusMeters: detectionRadius,
				clickable: /*index*/ ctx[23] == /*halte*/ ctx[0].idx,
				zIndex: /*index*/ ctx[23] == /*halte*/ ctx[0].idx
				? 19
				: /*haltePoints*/ ctx[4].length - /*index*/ ctx[23]
			}
		});

	spotmarkerlibre.$on("requestSelection", /*gotoNextHalte*/ ctx[6]);

	return {
		c() {
			create_component(spotmarkerlibre.$$.fragment);
		},
		m(target, anchor) {
			mount_component(spotmarkerlibre, target, anchor);
			current = true;
		},
		p(ctx, dirty) {
			const spotmarkerlibre_changes = {};
			if (dirty & /*haltePoints*/ 16) spotmarkerlibre_changes.isLast = /*index*/ ctx[23] == /*haltePoints*/ ctx[4].length - 1;
			if (dirty & /*haltePoints*/ 16) spotmarkerlibre_changes.coords = /*haltePoint*/ ctx[21];
			if (dirty & /*halte*/ 1) spotmarkerlibre_changes.isCurrent = /*index*/ ctx[23] == /*halte*/ ctx[0].idx;
			if (dirty & /*halte*/ 1) spotmarkerlibre_changes.showRadius = /*index*/ ctx[23] != /*halte*/ ctx[0].idx - 1;
			if (dirty & /*halte*/ 1) spotmarkerlibre_changes.clickable = /*index*/ ctx[23] == /*halte*/ ctx[0].idx;

			if (dirty & /*halte, haltePoints*/ 17) spotmarkerlibre_changes.zIndex = /*index*/ ctx[23] == /*halte*/ ctx[0].idx
			? 19
			: /*haltePoints*/ ctx[4].length - /*index*/ ctx[23];

			spotmarkerlibre.$set(spotmarkerlibre_changes);
		},
		i(local) {
			if (current) return;
			transition_in(spotmarkerlibre.$$.fragment, local);
			current = true;
		},
		o(local) {
			transition_out(spotmarkerlibre.$$.fragment, local);
			current = false;
		},
		d(detaching) {
			destroy_component(spotmarkerlibre, detaching);
		}
	};
}

// (220:8) <MapLibre startCoordinates={halte.coordinates} startZoom={15} onLoad={onMapLoaded}>
function create_default_slot(ctx) {
	let geolocationstartbutton;
	let t0;
	let usermarkerlibre;
	let t1;
	let mappointerbutton;
	let t2;
	let if_block_anchor;
	let current;
	geolocationstartbutton = new GeoLocationStartButton({});
	usermarkerlibre = new UserMarkerLibre({});

	mappointerbutton = new MapPointerButton({
			props: { active: /*autoCenteringActive*/ ctx[2] }
		});

	mappointerbutton.$on("statuschange", /*onHandleCenteringRequest*/ ctx[8]);
	let if_block = /*parcoursPath*/ ctx[3] && /*mapIsReady*/ ctx[1] && create_if_block_1(ctx);

	return {
		c() {
			create_component(geolocationstartbutton.$$.fragment);
			t0 = space();
			create_component(usermarkerlibre.$$.fragment);
			t1 = space();
			create_component(mappointerbutton.$$.fragment);
			t2 = space();
			if (if_block) if_block.c();
			if_block_anchor = empty();
		},
		m(target, anchor) {
			mount_component(geolocationstartbutton, target, anchor);
			insert(target, t0, anchor);
			mount_component(usermarkerlibre, target, anchor);
			insert(target, t1, anchor);
			mount_component(mappointerbutton, target, anchor);
			insert(target, t2, anchor);
			if (if_block) if_block.m(target, anchor);
			insert(target, if_block_anchor, anchor);
			current = true;
		},
		p(ctx, dirty) {
			const mappointerbutton_changes = {};
			if (dirty & /*autoCenteringActive*/ 4) mappointerbutton_changes.active = /*autoCenteringActive*/ ctx[2];
			mappointerbutton.$set(mappointerbutton_changes);

			if (/*parcoursPath*/ ctx[3] && /*mapIsReady*/ ctx[1]) {
				if (if_block) {
					if_block.p(ctx, dirty);

					if (dirty & /*parcoursPath, mapIsReady*/ 10) {
						transition_in(if_block, 1);
					}
				} else {
					if_block = create_if_block_1(ctx);
					if_block.c();
					transition_in(if_block, 1);
					if_block.m(if_block_anchor.parentNode, if_block_anchor);
				}
			} else if (if_block) {
				group_outros();

				transition_out(if_block, 1, 1, () => {
					if_block = null;
				});

				check_outros();
			}
		},
		i(local) {
			if (current) return;
			transition_in(geolocationstartbutton.$$.fragment, local);
			transition_in(usermarkerlibre.$$.fragment, local);
			transition_in(mappointerbutton.$$.fragment, local);
			transition_in(if_block);
			current = true;
		},
		o(local) {
			transition_out(geolocationstartbutton.$$.fragment, local);
			transition_out(usermarkerlibre.$$.fragment, local);
			transition_out(mappointerbutton.$$.fragment, local);
			transition_out(if_block);
			current = false;
		},
		d(detaching) {
			destroy_component(geolocationstartbutton, detaching);
			if (detaching) detach(t0);
			destroy_component(usermarkerlibre, detaching);
			if (detaching) detach(t1);
			destroy_component(mappointerbutton, detaching);
			if (detaching) detach(t2);
			if (if_block) if_block.d(detaching);
			if (detaching) detach(if_block_anchor);
		}
	};
}

function create_fragment(ctx) {
	let header;
	let t0;
	let div;
	let t1;
	let h2;
	let t2;
	let t3;
	let br;
	let t4;
	let t5_value = (/*halte*/ ctx[0] ? /*halte*/ ctx[0].title : '...') + "";
	let t5;
	let t6;
	let t7;
	let if_block_anchor;
	let current;
	header = new Header({ props: { title: "" } });
	let if_block = /*halte*/ ctx[0] && create_if_block(ctx);

	return {
		c() {
			create_component(header.$$.fragment);
			t0 = space();
			div = element("div");
			t1 = space();
			h2 = element("h2");
			t2 = text("En route vers la halte numéro ");
			t3 = text(/*halteNumber*/ ctx[5]);
			br = element("br");
			t4 = text("« ");
			t5 = text(t5_value);
			t6 = text(" »");
			t7 = space();
			if (if_block) if_block.c();
			if_block_anchor = empty();
			attr(div, "class", "headspacer");
			attr(h2, "class", "svelte-1bsnlr7");
		},
		m(target, anchor) {
			mount_component(header, target, anchor);
			insert(target, t0, anchor);
			insert(target, div, anchor);
			insert(target, t1, anchor);
			insert(target, h2, anchor);
			append(h2, t2);
			append(h2, t3);
			append(h2, br);
			append(h2, t4);
			append(h2, t5);
			append(h2, t6);
			insert(target, t7, anchor);
			if (if_block) if_block.m(target, anchor);
			insert(target, if_block_anchor, anchor);
			current = true;
		},
		p(ctx, [dirty]) {
			if (!current || dirty & /*halteNumber*/ 32) set_data(t3, /*halteNumber*/ ctx[5]);
			if ((!current || dirty & /*halte*/ 1) && t5_value !== (t5_value = (/*halte*/ ctx[0] ? /*halte*/ ctx[0].title : '...') + "")) set_data(t5, t5_value);

			if (/*halte*/ ctx[0]) {
				if (if_block) {
					if_block.p(ctx, dirty);

					if (dirty & /*halte*/ 1) {
						transition_in(if_block, 1);
					}
				} else {
					if_block = create_if_block(ctx);
					if_block.c();
					transition_in(if_block, 1);
					if_block.m(if_block_anchor.parentNode, if_block_anchor);
				}
			} else if (if_block) {
				group_outros();

				transition_out(if_block, 1, 1, () => {
					if_block = null;
				});

				check_outros();
			}
		},
		i(local) {
			if (current) return;
			transition_in(header.$$.fragment, local);
			transition_in(if_block);
			current = true;
		},
		o(local) {
			transition_out(header.$$.fragment, local);
			transition_out(if_block);
			current = false;
		},
		d(detaching) {
			destroy_component(header, detaching);
			if (detaching) detach(t0);
			if (detaching) detach(div);
			if (detaching) detach(t1);
			if (detaching) detach(h2);
			if (detaching) detach(t7);
			if (if_block) if_block.d(detaching);
			if (detaching) detach(if_block_anchor);
		}
	};
}

const detectionRadius = 35; // meters

function instance($$self, $$props, $$invalidate) {
	let { params } = $$props;
	let halte;
	let userPosition = geoLocationManager.currentCoords;
	let mapIsReady = false;
	let autoCenteringActive = false;
	let autoCenteringIntervalId = null;
	let triggerFlyToEvent = false;
	let parcoursPath;
	let haltePoints;
	let halteNumber = 0;
	let isLastHalte;

	onMount(() => {
		console.log("params", params);

		// this is only valid for a parcours step
		$$invalidate(0, halte = db.getStepForParentType(params.parcoursSlug, params.halteSlug, HalteParentType.parcours));

		$$invalidate(5, halteNumber = halte.idx + 1);
		$$invalidate(4, haltePoints = db.getHalteCoordsForParcours(halte.parentSlug));
		const parcours = db.getParcoursWithSlug(halte.parentSlug);
		isLastHalte = parcours.steps.length - 1 == halte.idx;
		mapEventProvider.addListener(onMapEvent);
	});

	onDestroy(() => {
		geoLocationManager.removeEventListener(GeolocationEventType.started, onGeoLocationStarted);
		geoLocationManager.removeEventListener(GeolocationEventType.significantCoords, onGeoLocationUpdate);
		geoLocationManager.removeEventListener(GeolocationEventType.stopped, onGeoLocationStopped);
		clearInterval(autoCenteringIntervalId);
		autoCenteringIntervalId = null;
		mapEventProvider.removeListener(onMapEvent);
	});

	function onMapEvent(event) {
		if (event.type === 'dragstart') {
			// stop autocentering
			if (autoCenteringActive) {
				$$invalidate(2, autoCenteringActive = false);
				clearInterval(autoCenteringIntervalId);
				autoCenteringIntervalId = null;
			}
		}
	}

	function stopAutoCentering() {
		if (autoCenteringActive) {
			$$invalidate(2, autoCenteringActive = false);
			clearInterval(autoCenteringIntervalId);
			autoCenteringIntervalId = null;
		}
	}

	function onGeoLocationStarted() {
		stopAutoCentering();
		triggerFlyToEvent = true;
	}

	function gotoNextHalte() {
		appRouter.show(`/parcours/${halte.parentSlug}/halte/${halte.slug}`);
	}

	function onGeoLocationUpdate(event) {
		// console.log("geo update on path page", event.value);
		// 1 update userPosition
		userPosition = event.value;

		// 2 check if we are in range of this halte
		const distanceUserSpot = distance(userPosition.coords, halte.coordinates) * 1000;

		if (distanceUserSpot < detectionRadius) {
			console.log("we are in detection range");
			gotoNextHalte();
		}

		// 3 check if we are in halte of other point
		const otherpoints = haltePoints.filter((point, index) => {
			return index > halte.idx || index < halte.idx - 1;
		});

		for (let i = 0; i < otherpoints.length; i++) {
			const point = otherpoints[i];
			const d = distance(userPosition.coords, point) * 1000;

			if (d < detectionRadius) {
				console.log("we are in detection range");
				const index = haltePoints.indexOf(point);
				const halteSlug = db.getHalteSlugForParcoursSludAndStepIndex(halte.parentSlug, index);
				appRouter.show(`/parcours/${halte.parentSlug}/halte/${halteSlug}`);
			}
		}

		// 4 trigge flyToEvent if required
		if (triggerFlyToEvent) {
			flyToMarkerAndUser();
			triggerFlyToEvent = false;
		}
	}

	function onGeoLocationStopped() {
		userPosition = null;
		stopAutoCentering();
		flyToMarkerAndUser();
	}

	function flyToMarkerAndUser() {
		let flyToOptions;

		if (userPosition && geoLocationManager.isStarted) {
			console.log("fly to marker and user");
			const bbox = computeBounds(userPosition.coords, halte.coordinates);

			// const bbox = getBbox([userPosition.coords, halte.coordinates]);
			flyToOptions = { bounds: bbox, padding: 10 };
		} else {
			console.log("fly to marker");
			flyToOptions = { coordinates: halte.coordinates, zoom: 15 };
		}

		flyToProvider.provide(flyToOptions);
	}

	async function onMapLoaded() {
		console.log("map ready");
		$$invalidate(1, mapIsReady = true);
		geoLocationManager.addEventListener(GeolocationEventType.started, onGeoLocationStarted);
		geoLocationManager.addEventListener(GeolocationEventType.significantCoords, onGeoLocationUpdate);
		geoLocationManager.addEventListener(GeolocationEventType.stopped, onGeoLocationStopped);
		const parcours = db.getParcoursWithSlug(halte.parentSlug);

		if (parcours.media.path) {
			$$invalidate(3, parcoursPath = await db.getParcoursPath(parcours.slug));
		} else {
			$$invalidate(3, parcoursPath = JSON.parse(lineFeatureCollectionFromPoints(haltePoints)));
		}
	}

	function centerHandler() {
		flyToMarkerAndUser();
	}

	function onHandleCenteringRequest(e) {
		$$invalidate(2, autoCenteringActive = e.detail.status);
		console.log("auto centering status change", autoCenteringActive);

		if (autoCenteringActive && !autoCenteringIntervalId) {
			console.log("start auto centering");
			autoCenteringIntervalId = setInterval(centerHandler, 5000);
			triggerFlyToEvent = false;
			centerHandler();
		} else {
			console.log("stop auto centering");
			clearInterval(autoCenteringIntervalId);
			autoCenteringIntervalId = null;
		}
	}

	$$self.$$set = $$props => {
		if ('params' in $$props) $$invalidate(9, params = $$props.params);
	};

	return [
		halte,
		mapIsReady,
		autoCenteringActive,
		parcoursPath,
		haltePoints,
		halteNumber,
		gotoNextHalte,
		onMapLoaded,
		onHandleCenteringRequest,
		params
	];
}

class EnCheminPage extends SvelteComponent {
	constructor(options) {
		super();
		init(this, options, instance, create_fragment, safe_not_equal, { params: 9 });
	}
}

export default EnCheminPage;